import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { useKioskStore } from '@/stores/useKioskStore'
import { useOrderStore } from '@/stores/useOrderStore';
import { useKioskRoute } from '@/composables/useKioskRoute';
import { useApi } from '@/composables/useApi';

export const useIdleStore = defineStore('idle', () => {
	const kioskStore = useKioskStore();
	const orderStore = useOrderStore();
	const router = useRouter();
	const route = useRoute();
	const { makePath } = useKioskRoute();
	const { request } = useApi();

	const { kioskId } = kioskStore;

	const isDevMode = ref(false);
	const isModalVisible = ref(false);

	let timeoutId = null;
	let alertTimeoutId = null;

	const startTimer = () => {
		if (route.name === 'CancelOrder') return;
		if (isDevMode.value) return;
		
		clearTimers();

		const timeout = (kioskStore.timeout || 30) * 1000;

		timeoutId = window.setTimeout(() => {
			isModalVisible.value = true;

			alertTimeoutId = window.setTimeout(async () => {
				if (isModalVisible.value) {
					await playIdleVideo();
				}
			}, 10000);
		}, timeout);
	}

	const resetTimer = () => {
		if (isDevMode.value) return;
		startTimer();
	}

	const clearTimers = () => {
		if (timeoutId) {
			clearTimeout(timeoutId);
			timeoutId = null;
		}
		if (alertTimeoutId) {
			clearTimeout(alertTimeoutId);
			alertTimeoutId = null;
		}
	}

	const continueUsage = () => {
		isModalVisible.value = false;
		startTimer();
	}

	const cancelUsage = async () => {
		clearTimers();
		orderStore.clearCart();
		await router.push(makePath('/'));
		await playIdleVideo();
	}

	const setDevMode = (value) => {
		isDevMode.value = value;
	};

	async function playIdleVideo() {
		await request(`/api/${kioskId}/mqtt/timeout`);
	}

	return {
		isDevMode,
		isModalVisible,
		startTimer,
		resetTimer,
		clearTimers,
		continueUsage,
		playIdleVideo,
		cancelUsage,
		setDevMode,
	}
});
